export class Slider {

    constructor(Swiper, modules)
    {
        this.init()
        Object.keys(this.sliders).forEach(slider => {
            let _slider = document.querySelector('.' + slider)
            if (!_slider) {
                return;
            }
            this.sliders[slider](Swiper, modules, _slider)
        })
    }

    init() // register sliders here
    {
        this.sliders = { // className: function
            'slider-1': this.sliderHome,
            'testimonial-slider': this.testimonialSlider,
            'partner-slider': this.partnerSlider,
            'realisations-slider': this.realisationsSlider,
            'archive-swiper-application-web-et-mobile' : this.mobileSlider,
            'archive-swiper-developpement-web' : this.devSlider,
            'archive-swiper-site-internet-institutionnel' : this.siteSlider,
            'archive-swiper-site-e-commerce' : this.commerceSlider,
        }
    }

    testimonialSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            breakpoints: {
                100: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 320px
                450: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 480px
                750: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
            },
        });
    }

    realisationsSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            breakpoints: {
                100: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 320px
                450: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 480px
                750: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });
    }


    partnerSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            modules: modules,
            loopFillGroupWithBlank: false,
            autoplay: {
                delay: 5000,
            },
            loop: true,
            speed: 1000,
            breakpoints: {
                100: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 320px
                450: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
                // when window width is >= 480px
                750: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 5,
                    slidesPerGroup: 1,
                },
            },

        });
    }

    mobileSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 60,
            loop: false,
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                999: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }

    devSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 60,
            loop: false,
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                999: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }

    siteSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 60,
            loop: false,
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                999: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }

    commerceSlider(Swiper, modules, slider)
    {
        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 60,
            loop: false,
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                999: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            },
            modules: modules,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }

  sliderHome(Swiper, modules, slider)
  {
    new Swiper(slider, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: false,
      draggable: true,
      breakpoints: {
      },
      modules: modules,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

  }



}



// WEBPACK FOOTER //
// ./js/scripts/Slider.js